/**
 * ページネーションに関する定数
 */

/**
 * スタッフ検索結果の1ページあたりの表示件数
 */
export const STAFF_SEARCH_PER_PAGE = 50;
